import React, { Component, Fragment } from "react";
// import firebase from "../../firebase";
import {MyStore} from '../../../../services/Store'
import { Route, NavLink, Link, Redirect, withRouter} from 'react-router-dom';
import {
    Menu,
    Icon,
    Modal,
    Form,
    Input,
    Button,
    Message,
    Label,
    Container,
    Card,
    Image, 
    Grid, 
    Dropdown
} from "semantic-ui-react";

class PatientProject  extends Component {
        constructor(props){
        super(props)
        // console.log(props)

        // this.mbrProjectsRef= MyStore.database().ref("groups").child(groupId).child('mbrprojects').child(currentUser.uid)

        
        this.state = {
            user: this.props.currentUser,
            // user: MyStore.auth().currentUser,
            // notifications: this.props.notifications,
            activeConvoId: props.activeConvoId,
            groups: [],
            showModal: false,
            groupName: "",
            groupDetails: "",
            groupsRef:   MyStore.database().ref("groups"),
            // cardsRef: MyStore.database().ref('cards').child('-LwLujWwcsr6szQxZYer'),
            cardsRef: MyStore.database().ref('cards').child(this.props.oid),
            // dmRef: MyStore.database().ref("directMessages"),
            usersRef:   MyStore.database().ref("users"),
            // groupsRef: MyStore.database().ref().child("groups"),
            // dmRef: MyStore.database().ref().child("directMessages"),
            firstLoad: true,
            errors: [],
            activeItem: props.activeConvoId,
        };
    }


    handleItemClick = (e, { name }) => {
        this.setState({ activeItem: name })
        // this.handleItemClick()
    }

    nextPath(path) {
        this.props.history.push(path);
      }


    displayErrors = errors =>
        errors.map((e, index) => <p key={index}>{e.message}</p>);

    displayGroups = groups =>
        groups.length > 0 &&
        groups.map(group => (
            <Menu.Item 
                key={group.cardId}
                onClick={() => this.props.changeGroup(group)}
               
                name={group.name}
                style={{  background: '#77E97F', color: '#6D6D6D' }}
                // active={group.id === this.state.activeConvoId}
                 active={this.state.activeItem === group.mrn}
                 
                >
                    
                       <Label>51</Label>
                 {group.age}  {group.gender}  {group.name}  {group.mrn}

                 {/* (this.state.age)+' ' + (this.state.gender)  + ' ' + (this.state.name) +' '+ (mrn)  */}
                {/* {this.getNotifications(group.id) > 0 && (
                    <Label color="red">{this.getNotifications(group.id)}</Label>
                )} */}

            </Menu.Item>
        ));


        // displayCards = groups =>
        // groups.length > 0 &&
        // groups.map(group => (
        //     <Card.Group 
        //         key={group.cardId}
        //         onClick={() => this.props.changeGroup(group)}
               
        //         name={group.name}
        //         style={{  background: '#77E97F', color: '#6D6D6D' }}
        //         // active={group.id === this.state.activeConvoId}
        //          active={this.state.activeItem === group.mrn}
                 
        //         >
                    
        //                <Label>51</Label>
        //          {group.age}  {group.gender}  {group.name}  {group.mrn}

        //          {/* (this.state.age)+' ' + (this.state.gender)  + ' ' + (this.state.name) +' '+ (mrn)  */}
        //         {/* {this.getNotifications(group.id) > 0 && (
        //             <Label color="red">{this.getNotifications(group.id)}</Label>
        //         )} */}

        //     </Card.Group>
        // ));
    
    toOrgan=(e)=>{
        // e.preventDefault()
        
        // console.log(e)
        // console.log(e.target.value)
        this.nextPath(`/dashboard/${e.target.value}`)
       
        // console.log('------------id  groups.js')

    }

  

    // openModal = () => {
    //     this.setState({
    //         showModal: true
    //     });
    // };

    // closeModal = () => {
    //     this.setState({
    //         showModal: false
    //     });
    // };

 

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };


    /**
     * Set initial active group to first group in state
     * upon first page load
     */
    setFirstGroup = () => {
        const { groups, firstLoad } = this.state;
        if (firstLoad && groups.length > 0) {
            this.props.changeGroup(groups[0]);
        }
        this.setState({ firstload: false });
    };

    

    addGroupToUser = (snap, groupId) => {
        const { user, usersRef } = this.state;
        let userGroups = snap.child("groups").val();

        if (!userGroups) {
            userGroups = {};
        }

        userGroups[groupId] = {
            groupId: groupId,
            isMember: true
        };

        usersRef.child(user.uid).update({
            groups: userGroups
        });
    };


    /**
     * Add groups belonging to user into component state so that
     * users will only see groups in the sidebar that they are
     * a member of
     */
    addGroupListener = () => {
        let loadedGroups = [];
        const { user, usersRef, groupsRef } = this.state;
        // console.log(usersRef)
        // const { addNotificationListener } = this.props;

        // Listen for new groups in groups child under users ref
        if(user){
            MyStore.auth().onAuthStateChanged(() => {
          
                const loadedGroups = [];
                    // mbrProjectsRef.child('cards')
                    // MyStore.database().ref("groups").child('-LwLujWwcsr6szQxZYer').child('mbrprojects').child(user.uid).child('cards')
                    MyStore.database().ref("groups").child(this.props.oid).child('mbrprojects').child(user.uid).child('cards')
    
                    .on("child_added", snap => {
                        let cardId = snap.val().id;
                        // console.log(cardId)
                        // groupsRef.child('-LwLujWwcsr6szQxZYer').child('cards').child(cardId).once("value", snap => {
                          groupsRef.child(this.props.oid).child('cards').child(cardId).once("value", snap => {
                            // loadedGroups.push(Object.assign({}, snap.val()));
                            // console.log( snap.val())
                            let data = snap.val();
                            if(data){
                              loadedGroups.push(Object.assign({},data));
                            }
                        });
                                //  console.log(loadedGroups)
                                 this.setState({groups:loadedGroups })
                        if (snap.val() == null) {
                            this.setState({groups: []})
               
                      }
             
                    });
            
         
                  })

 





        }
        else{
            return
        }

    };

    removeGroupListener = () => {
        this.state.usersRef.off();
    };

    /**
     * COMPONENT LIFECYCLE METHODS
     */
    static getDerivedStateFromProps(nextProps) {
        return {
            activeConvoId: nextProps.activeConvoId
        };
    }

    componentDidMount() {
      // console.log(this.props)
        this.addGroupListener();
    }

    // componentDidUpdate(){
    //     this.addGroupListener();
    // }

    componentWillUnmount() {
        this.removeGroupListener();
    }


    loadChatRoom(activeItem, groups){
        return(
            <Menu size='large' vertical    >
    <Menu.Item>
      <Input placeholder='Search...' />
    </Menu.Item>
    {this.displayGroups(groups)}




    
    <Menu.Item>
      Home
      <Menu.Menu>
        <Menu.Item
          name='search'
          active={activeItem === 'search'}
          onClick={this.handleItemClick}
        >
          Search
        </Menu.Item>
        <Menu.Item
          name='add'
          active={activeItem === 'add'}
          onClick={this.handleItemClick}
        >
          Add
        </Menu.Item>
        <Menu.Item
          name='about'
          active={activeItem === 'about'}
          onClick={this.handleItemClick}
        >
          Remove
        </Menu.Item>
      </Menu.Menu>
    </Menu.Item>

    <Menu.Item
      name='browse'
      active={activeItem === 'browse'}
      onClick={this.handleItemClick}
    >
      <Icon name='grid layout' />
      Browse
    </Menu.Item>
    <Menu.Item
      name='messages'
      active={activeItem === 'messages'}
      onClick={this.handleItemClick}
    >
      Messages
    </Menu.Item>

    <Dropdown item text='More'>
      <Dropdown.Menu>
        <Dropdown.Item icon='edit' text='Edit Profile' />
        <Dropdown.Item icon='globe' text='Choose Language' />
        <Dropdown.Item icon='settings' text='Account Settings' />
      </Dropdown.Menu>
    </Dropdown>
  </Menu>
        )
    }

    render() {
        const { activeItem, groups } = this.state
        return (
            <Fragment>

            {this.loadChatRoom(activeItem, groups)}
            </Fragment>
        );
    }
}

export default PatientProject;
// export default withRouter(PatientProject);